module.exports = __webpack_public_path__ + "img/sunnet.5c76ba39.png";